<template>
  <component v-if="mode"
              :is="currentComponent"
              ref="innerComponent"
              :link="params.link"
              :buyers-dossier="params.buyers"
              :link-embed="params.linkEmbed"
              :adv-dossier="params.adv"
              :selected-document="params.source"
              :promoteur-contact="params.source"
              :notaire-contact="params.source"
              :adv-pk="params.source"
              :id-buyer="params.idBuyer"
              :id-adv="params.idAdv"
              :you-sign="params.youSign"
              :active="active"
              :params="params"
              :facture="params.facture"
              :mode="params.mode"
              :ratio="params.ratio"
              :circle="params.circle"
              :index="params.index"
              @submit="submit"
              @confirm="confirm"
              @close="close"
              @goToSign="goToSign"
              class="quickview-block">
  </component>
</template>

<script>
  import { bus, EVENTS } from '@/services/bus/index.js'
  // import { isNil } from 'lodash'
  import DocumentModalEdit from '../utils/DocumentModalEdit'
  import DocumentModalPreview from '../utils/DocumentModalPreview'
  import VideoPreview from './VideoPreview'
  import DocumentsSelection from './DocumentsSelection'
  import PromoteurContact from './PromoteurContact'
  import NotaireContact from './NotaireContact'
  import DossierResa from './DossierResa'
  import CancelProcedure from './CancelProcedure'
  import ProcedureModal from './ProcedureModal'
  import { mapState } from 'vuex'

  const MODES = Object.freeze({
    DOCUMENT_EDIT: 'DOCUMENT_EDIT',
    DOCUMENT_PREVIEW: 'DOCUMENT_PREVIEW',
    PROCEDURE_MODAL: 'PROCEDURE_MODAL',
    VIDEO_PREVIEW: 'VIDEO_PREVIEW',
    DOCUMENTS_SELECTION: 'DOCUMENTS_SELECTION',
    PROMOTEUR_CONTACT: 'PROMOTEUR_CONTACT',
    DOSSIER_RESA: 'DOSSIER_RESA',
    NOTAIRE_CONTACT: 'NOTAIRE_CONTACT',
    CANCEL_PROCEDURE: 'CANCEL_PROCEDURE'
  })

  export default {
    name: 'Modal',
    components: {
      DocumentModalEdit,
      DocumentModalPreview,
      VideoPreview,
      DocumentsSelection,
      PromoteurContact,
      DossierResa,
      NotaireContact,
      CancelProcedure,
      ProcedureModal
    },
    data () {
      return {
        MODES: MODES,
        mode: null,
        active: false,
        params: {},
        results: {},
        loading: false
      }
    },
    watch: {
      modal ({mode = null, params = null, results = null}) {
        if (mode && !results) {
          this.open({mode, params})
        } else {
          this.close()
        }
      }
    },
    computed: {
      ...mapState(['modal']),
      currentComponent () {
        const components = {
          [MODES.DOCUMENT_EDIT]: 'DocumentModalEdit',
          [MODES.DOCUMENT_PREVIEW]: 'DocumentModalPreview',
          [MODES.PROCEDURE_MODAL]: 'ProcedureModal',
          [MODES.VIDEO_PREVIEW]: 'VideoPreview',
          [MODES.DOCUMENTS_SELECTION]: 'DocumentsSelection',
          [MODES.PROMOTEUR_CONTACT]: 'PromoteurContact',
          [MODES.NOTAIRE_CONTACT]: 'NotaireContact',
          [MODES.DOSSIER_RESA]: 'DossierResa',
          [MODES.CANCEL_PROCEDURE]: 'CancelProcedure'
        }
        return components[this.mode]
      }
    },
    methods: {
      open ({mode, params}) {
        this.mode = mode
        this.params = Object.assign({}, params)
        this.active = true
        console.log(params)
      },
      close () {
        this.mode = null
        this.params = null
        this.active = false
      },
      submit (results) {
        this.$store.commit('setModal', {mode: this.mode, params: this.params, results: results})
        this.close()
      },
      confirm (results) {
        this.$store.commit('setModal', {mode: this.mode, params: this.params, results: results})
        this.close()
      },
      // confirmComment (results) {
      //   this.$store.commit('setModal', {mode: this.mode, params: this.params, results: results})
      //   this.close()
      // },
      goToSign () {
        bus.$emit(EVENTS.LINK_SIGNATURE)
        this.close()
      }
    },
    mounted () {
      // bus.$on(EVENTS.OPEN_MODAL, ({mode, params}) => {
      //   if (isNil(params)) params = {}
      //   this.open(mode, params)
      // })
      // bus.$on(EVENTS.CLOSE_MODAL, () => {
      //   this.close()
      // })
      bus.$on(EVENTS.LOADING, (v) => {
        if (v) this.loading = true
        else this.loading = false
      })
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/modal/Modal.vue